// @ts-check

angular.module('checkout').service(
    'checkoutEnrollment',
    [
        '$window',
        '$location',
        '$http',
        'rcmEventManager',
        'rcmLoading',
        'rcmApiLibService',
        'rcmApiLibMessageService',
        'orderMgr',
        /** @type {import('angular').IControllerConstructor} */ function (
            /** @type {import('angular').IWindowService} */ $window,
            /** @type {import('angular').ILocationService} */ $location,
            $http,
            rcmEventManager,
            rcmLoading,
            rcmApiLibService,
            rcmApiLibMessageService,
            /** @type {import('cart-core').CartOrderManager} */ orderMgr
        ) {

            /**
             * self
             */
            let self = this;

            /**
             * @type {boolean}
             */
            self.hasMessage = false;

            /**
             * apiUrlPaths
             * @type {Record<string, string>}
             */
            let apiUrlPaths = {
                tempProfileGetCurrent: '/api/checkout/order/{orderId}/temp-profile/current',
                tempProfileGetNew: '/api/checkout/order/{orderId}/temp-profile/new',
                tempProfileCreate: '/api/checkout/order/{orderId}/temp-profile',
                profileCreate: '/api/checkout/profile',
                userLogout: '/api/rcm-user/user/logout',
                userLogin: '/api/rcm-user/user/login',
            };

            /**
             * order
             * @type {null}
             */
            self.order = orderMgr.getOrder();

            /**
             * createProfile
             * @param profile
             * @param success
             * @param error
             * @param loading
             */
            self.createProfile = function (profile, success, error, loading) {
                if (self.order.attributes.currentUserRules.loggedIn) {
                    self.logout(
                        function () {
                            self.saveProfile(
                                profile,
                                getOnCreateProfileSuccess(profile, success, error),
                                error,
                                loading
                            );
                        },
                        getOnLogoutError(error)
                    );
                    return;
                }
                self.saveProfile(
                    profile,
                    getOnCreateProfileSuccess(profile, success, error),
                    error,
                    loading
                );
            };

            /**
             * saveProfile General Save
             * @param profile
             * @param success
             * @param error
             * @param loading
             */
            self.saveProfile = function (profile, success, error, loading) {
                rcmApiLibService.post(
                    {
                        url: apiUrlPaths.profileCreate,
                        data: profile,
                        loading: getOnLoading(loading),
                        success: success,
                        error: error,
                    }
                );
            };

            /**
             * createTempProfile
             * @param profile
             * @param success
             * @param error
             * @param loading
             */
            self.createTempProfile = function (profile, success, error, loading) {
                profile = self.buildProfile(profile);
                if (self.order.attributes.currentUserRules.loggedIn) {
                    self.logout(
                        function () {
                            self.saveTempProfile(
                                profile,
                                success,
                                error,
                                loading
                            );
                        },
                        getOnLogoutError(error)
                    );
                    return;
                }

                self.saveTempProfile(profile, success, error, loading);
            };

            /**
             * updateTempProfile
             * @param profile
             * @param success
             * @param error
             * @param loading
             */
            self.updateTempProfile = function (profile, success, error, loading) {
                profile = self.buildProfile(profile);
                self.saveTempProfile(profile, success, error, loading);
            };

            /**
             * getCurrentTempProfile
             * @param success
             * @param error
             * @param loading
             */
            self.getCurrentTempProfile = function (success, error, loading) {

                rcmApiLibService.get(
                    {
                        url: apiUrlPaths.tempProfileGetCurrent,
                        urlParams: {orderId: self.order.id},
                        loading: getOnLoading(loading),
                        success: success,
                        error: error,
                    }
                );
            };

            /**
             * getNewTempProfile
             * @param success
             * @param error
             * @param loading
             */
            self.getNewTempProfile = function (success, error, loading) {

                rcmApiLibService.get(
                    {
                        url: apiUrlPaths.tempProfileGetNew,
                        urlParams: {orderId: self.order.id},
                        loading: getOnLoading(loading),
                        success: success,
                        error: error,
                    }
                );
            };

            /**
             * saveTempProfile General Save
             * @param profile
             * @param success
             * @param error
             * @param loading
             */
            self.saveTempProfile = function (profile, success, error, loading) {

                rcmApiLibService.post(
                    {
                        url: apiUrlPaths.tempProfileCreate,
                        urlParams: {orderId: 'current'},
                        data: profile,
                        loading: getOnLoading(loading),
                        success: getOnSaveTempProfileSuccess(success, error),
                        error: error,
                    }
                );
            };

            /**
             * buildProfile
             * @param profile
             * @returns {*}
             */
            self.buildProfile = function (profile) {
                if (self.order.attributes.currentUserRules.loggedIn) {
                    profile.rcn = self.order.attributes.currentUserRules.profile.rcn;
                }

                return profile;
            };

            /**
             * getOnLoading
             * @param loadingCallback
             * @returns {Function}
             */
            let getOnLoading = function (loadingCallback) {
                return function (loading) {
                    if (typeof loadingCallback === 'function') {
                        loadingCallback(loading);
                    }

                    let loadingInt = Number(!loading);
                    rcmLoading.setLoading(
                        'checkoutEnrollment.loading',
                        loadingInt
                    );
                };
            };

            /**
             * getOnLogoutError
             * @param errorCallback
             * @returns {Function}
             */
            let getOnLogoutError = function (errorCallback) {
                return function (response) {
                    if (typeof errorCallback === 'function') {
                        errorCallback(response);
                    }
                };
            };

            /**
             * getOnCreateProfileSuccess
             * @param profile
             * @param successCallback
             * @param errorCallback
             * @returns {Function}
             */
            let getOnCreateProfileSuccess = function (profile, successCallback, errorCallback) {
                return function (response) {
                    self.login(
                        profile,
                        function (loginResponse) {
                            if (typeof successCallback === 'function') {
                                successCallback(response);
                            }
                        },
                        function (loginResponse) {
                            if (typeof errorCallback === 'function') {
                                errorCallback(loginResponse);
                            }
                        }
                    );
                };
            };

            /**
             * getOnSaveTempProfileSuccess
             * @param successCallback
             * @param errorCallback
             * @returns {Function}
             */
            let getOnSaveTempProfileSuccess = function (successCallback, errorCallback) {
                return function (response) {
                    let profile = response.data;
                    self.addEnrollmentItems(
                        profile,
                        function () {
                            if (typeof successCallback === 'function') {
                                successCallback(response);
                            }
                        },
                        function (orderResponse) {
                            if (typeof errorCallback === 'function') {
                                errorCallback({data: profile, messages: orderResponse.messages});
                            }
                        }
                    );
                };
            };

            /**
             * addEnrollmentItems
             * @param profile
             * @param success
             * @param error
             */
            self.addEnrollmentItems = function (profile, success, error) {

                let requiredItems = profile.requiredEnrollmentSkus;

                if (!requiredItems.length || requiredItems.length <= 0) {
                    success({data: profile, messages: []});
                    return;
                }

                let items = [];
                angular.forEach(
                    requiredItems,
                    function (value, key) {
                        items.push(
                            {
                                skuNumber: value,
                                qty: 1,
                                type: 'enrollment',
                            }
                        );
                    }
                );

                /**
                 * @todo 2021-04-23 - bharms@relivinc.com - axosoft/25604:
                 * No analytics tracking is currently performed by this function.
                 * Add support for server-side tracking when the function is
                 * called. It will need to be able to identify the source of the
                 * event to the server from here, although the actual event will
                 * not be fired from here.
                 */
                orderMgr.setItems(
                    items,
                ).then(success, error);
            };

            /**
             * logout
             * @param success
             * @param error
             * @param loading
             */
            self.logout = function (success, error, loading) {
                rcmApiLibService.post(
                    {
                        url: apiUrlPaths.userLogout,
                        data: {},
                        loading: getOnLoading(loading),
                        success: success,
                        error: error,
                    }
                );
            };

            /**
             * login
             * @param profile
             * @param success
             * @param error
             * @param loading
             */
            self.login = function (profile, success, error, loading) {

                let user = {
                    username: profile.username,
                    password: profile.password,
                };

                rcmApiLibService.post(
                    {
                        url: apiUrlPaths.userLogin,
                        data: user,
                        loading: getOnLoading(loading),
                        success: success,
                        error: error,
                    }
                );
            };

            /**
             * redirectToPage
             * @param page
             */
            self.redirectToPage = function (page) {
                $window.location.href = '/checkout?reload=1#' + page;
            };

            /**
             * goToPage
             * @param page
             */
            self.goToPage = function (page) {
                $location.path(page);
            };

            /** ##### MESSAGE HANDLERS ##### **/

            /**
             * setMessage
             * @param message
             * @param namespace
             */
            self.setMessage = function (message, namespace) {
                rcmApiLibMessageService.setMessage(message, namespace);
                self.hasMessage = true;
            };

            /**
             * clearMessages
             * @param namespace
             */
            self.clearMessages = function (namespace) {
                rcmApiLibMessageService.clearMessages(namespace);
                self.hasMessage = false;
            };

            /**
             * handleMessages
             * @param messages
             * @param onFieldMessages
             * @param onPrimaryMessage
             * @param namespace
             */
            self.handleMessages = function (messages, onFieldMessages, onPrimaryMessage, namespace) {
                rcmApiLibMessageService.getTypeMessages(
                    messages,
                    'validatorMessage',
                    onFieldMessages
                );

                self.clearMessages(namespace);

                rcmApiLibMessageService.getPrimaryMessage(
                    messages,
                    function (message) {
                        self.setMessage(message, namespace);
                        if (typeof onPrimaryMessage === 'function') {
                            onPrimaryMessage(message);
                        }
                    }
                );
            };

            /** ##### EVENT HANDLERS ##### **/

            /**
             * onOrderChange
             * @param order
             */
            let onOrderChange = function (order) {
                self.order = order;
            };

            /**
             * on orderMgr.orderChange
             */
            rcmEventManager.on(
                'orderMgr.orderChange',
                onOrderChange,
                'checkoutEnrollment'
            );
        },
    ]
);
